import { SxProps, Theme } from '@mui/system';

const styles = {
  root: {
    padding: '24px',
  },

  tableContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '40px',
  },

  tableTitleFont: {
    fontSize: 18,
    fontWeight: 600,
  },

  button: {
    width: '140px',
  },

  tableContainer: {
    padding: '0px 32px 32px 32px',
  },

  container: {
    boxSizing: 'border-box',
    width: '100%',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
